import { Component, OnInit, ViewChild } from '@angular/core';
import { InventoryService } from '../../Services/inventory.service';
import { InventoryRequestModel, InventoryResponseModel } from '../../Models/Inventory/inventory-filters';
import { DropDownService } from '../../Services/DropDown/dropdownService';
import { RegionModel, RMHModel } from '../../models/DropDwon/RegionModel';
import { ZoneModel } from '../../models/DropDwon/ZoneModel';
import { DivisionModel } from '../../models/DropDwon/DvisionModel';
import { SBUModel } from '../../models/DropDwon/SBUModel';
import { DropDownRequest, DropDownResponse, WHLocationModel, SDModel } from '../../models/DropDwon/DropDownRequest';
import { productModel } from '../../models/DropDwon/ProductModel';
import { CropModel } from '../../models/DropDwon/CropModel';
import { ToastrService } from 'ngx-toastr';
import { saveAs } from 'file-saver';
import { PagerService } from '../../Services/pager.service';

@Component({
  selector: 'app-inventory',
  templateUrl: './inventory.component.html'
  //styleUrls: ['./inventory.component.css']
})
export class InventoryComponent implements OnInit {

  @ViewChild('regionSelect') regionSelect;
  @ViewChild('warehouseLocation') warehouseLocation;
  @ViewChild('productSelect') productSelect;
  @ViewChild('sbu') sbu;
  @ViewChild('division') division;
  @ViewChild('zone') zone;
  @ViewChild('rmh') rmh;

  public dropdownMonthSettings: {};

  public RegionSettings = {};
  public RegionselectedItems: RegionModel[];

  public ProductSettings = {};
  public ProductSelectedItem: productModel[];

  public RMHSettings = {};
  public RMHSelectedItems: RMHModel[];

  public WarehouseLocationSettings = {};
  public WarehouseLocationSelectedItem: productModel[];

  public SBUSettings = {};
  public SBUSelectedItem: SBUModel[];

  public DivisionSettings = {};
  public DivisionSelectedItem: DivisionModel[];

  public ZoneSettings = {};
  public ZoneSelectedItem: ZoneModel[];

  public userId: string;
  public roleId: string;
  public FlagDropDown: string;
  public loader: string = "none";
  public files: File[] = [];
  public fileName: string = '';
  public ddlRequest: DropDownRequest = new DropDownRequest();
  public ddlResponse: DropDownResponse = new DropDownResponse();
  public whlocationList: WHLocationModel[];

  public invRequestModel: InventoryRequestModel = new InventoryRequestModel();
  public invResponseModel: Array<InventoryResponseModel> = new Array<InventoryResponseModel>();
  public defaultValue: Boolean = true;
  //Start: varibales for pagination
  pager: any = {};
  model: any[];
  pageSetting: number = 10;
  modalSetting: number = 0;
  modelFilter: any[];
  modelDepandent: any[];
  selectedPaging: any;

  totalRecord: any;
  currentPage: any;
  lastPage: any;
  isDisabledPrevious = true;
  isDisabledNext = false;
  defaultView: boolean = true;
  recordsOnCurrentPage: any = 10;
  currentDate = new Date();
  startRecord: any = 1;
  pagination: any[];
  userName: string;
  selectedProduct: any[] = [];
  commaSeperatedProduct: string;
  //END: varibales for pagination

  constructor(private inventoryService: InventoryService, private ddlServices: DropDownService, private toastr: ToastrService, private _pagerService: PagerService) {
    this.userId = localStorage.getItem('dsu_userId');
    this.userName = localStorage.getItem('dsu_userName')
    this.roleId = localStorage.getItem('dsu_roleId');
    this.FlagDropDown = "DEFAULT";


  }

  ngOnInit() {
    this.loader = 'block';
    this.selectedPaging = '0';
    this.ddlRequest.UserId = this.userId;
    this.ddlRequest.Role = this.roleId;
    this.ddlRequest.Flag = this.FlagDropDown;
    this.ddlServices.getAllHierarchyDropDown(this.ddlRequest)
      .subscribe((response) => {
        if (response.status) {
          this.ddlResponse = response.data;
          this.GetSDData();
          this.GetWarehouseLocationData();
          this.loader = 'none';
        }
        else {
          this.loader = 'none';
          this.toastr.error(response.message);
        }

      }, error => {
        this.loader = 'none';
      });

    this.SBUMHSetting();
    this.DivisionSetting();
    this.ZoneSetting();
    this.RegionSetting();
    this.RMHSetting();
    this.WareHouseLocationSetting();
    this.ProductSetting();

  }


  RegionSetting() {
    this.RegionSettings = {
      singleSelection: false,
      idField: 'regionCode',
      textField: 'regionName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      //maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Region Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  RMHSetting() {
    this.RMHSettings = {
      singleSelection: false,
      idField: 'rmhCode',
      textField: 'rmhName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      //maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No RMH Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  ProductSetting() {
    this.ProductSettings = {
      singleSelection: false,
      idField: 'productId',
      textField: 'productName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Product Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  public onRegionSelect(item: any) {
    if (this.roleId != '42') {
      this.GetRegionWiseData(this.regionSelect.selectedItems);
    }
  }
  public onRegionDeSelect(item: any) {
    if (this.roleId != '42') {
      this.GetRegionWiseData(this.regionSelect.selectedItems);
    }
  }

  public onRegionSelectAll(items: any) {
    if (this.roleId != '42') {
      this.GetRegionWiseData(this.regionSelect.selectedItems);
    }
  }
  public onRegionDeSelectAll(items: any) {
    this.rmh.selectedItems = [];
    //this.GetRegionWiseData(this.regionSelect.selectedItems);
  }
  public onRMHSelect(item: any) {
    this.GetRMHWiseData(this.rmh.selectedItems);
  }
  public onRMHDeSelect(item: any) {
    this.GetRMHWiseData(this.rmh.selectedItems);
  }

  public onRMHSelectAll(items: any) {
    this.GetRMHWiseData(this.rmh.selectedItems);
  }
  public onRMHDeSelectAll(items: any) {
    this.regionSelect.selectedItems = [];
    //this.GetRMHWiseData(this.rmh.selectedItems);
  }

  public onProductSelect(item: any) {
    this.selectedProduct = [];
    for (var i = 0; i < this.productSelect.selectedItems.length; i++) {
      this.selectedProduct.push(this.productSelect.selectedItems[i].text)
    }
    this.commaSeperatedProduct = this.selectedProduct.join(", ");
  }
  public onProductDeSelect(item: any) {
    this.selectedProduct = [];
    for (var i = 0; i < this.productSelect.selectedItems.length; i++) {
      this.selectedProduct.push(this.productSelect.selectedItems[i].text)
    }
    this.commaSeperatedProduct = this.selectedProduct.join(", ");
  }

  public onProductSelectAll(items: any) {
    this.selectedProduct = [];
    for (var i = 0; i < this.productSelect.selectedItems.length; i++) {
      this.selectedProduct.push(this.productSelect.selectedItems[i].text)
    }
    this.commaSeperatedProduct = this.selectedProduct.join(", ");
  }
  public onProductDeSelectAll(items: any) {
    this.selectedProduct = [];
    this.commaSeperatedProduct = '';
  }
  WareHouseLocationSetting() {
    this.WarehouseLocationSettings = {
      singleSelection: false,
      idField: 'whId',
      textField: 'whName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Warehouse Location Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  SBUMHSetting() {
    this.SBUSettings = {
      singleSelection: false,
      idField: 'sbuCode',
      textField: 'sbuName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No SBU Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  DivisionSetting() {
    this.DivisionSettings = {
      singleSelection: false,
      idField: 'divisionCode',
      textField: 'divisionName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Division Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  ZoneSetting() {
    this.ZoneSettings = {
      singleSelection: false,
      idField: 'zoneCode',
      textField: 'zoneName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Zone Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  bindMonthDropdownSetting() {
    this.dropdownMonthSettings = {
      singleSelection: false,
      text: "Select Month",
      idField: 'Id',
      textField: 'Text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true,
      noDataAvailablePlaceholderText: 'No Month Found'
    };
  }

  public onSBUSelect(item: any) {
    this.GetSBUWiseData(this.sbu.selectedItems);
  }
  public onSBUDeSelect(item: any) {
    this.GetSBUWiseData(this.sbu.selectedItems);
  }

  public onSBUSelectAll(items: any) {
    this.GetSBUWiseData(this.sbu.selectedItems);
  }
  public onSBUDeSelectAll(items: any) {
    this.GetSBUWiseData(this.sbu.selectedItems);
  }

  public onDivisionSelect(item: any) {
    this.GetDivisionWiseData(this.division.selectedItems);

  }
  public onDivisionDeSelect(item: any) {
    this.GetDivisionWiseData(this.division.selectedItems);
  }

  public onDivisionSelectAll(items: any) {
    this.GetDivisionWiseData(this.division.selectedItems);
  }
  public onDivisionDeSelectAll(items: any) {
    this.GetDivisionWiseData(this.division.selectedItems);
  }

  public onZoneSelect(item: any) {

    this.GetZoneWiseData(this.zone.selectedItems);
  }
  public onZoneDeSelect(item: any) {
    this.GetZoneWiseData(this.zone.selectedItems);
  }

  public onZoneSelectAll(items: any) {
    this.GetZoneWiseData(this.zone.selectedItems);
  }
  public onZoneDeSelectAll(items: any) {
    this.rmh.selectedItems = [];
    this.regionSelect.selectedItems = [];
    this.GetZoneWiseData(this.zone.selectedItems);
  }

  GetSBUWiseData(filter: any) {
    this.loader = 'block';
    this.ddlRequest.UserId = this.userId;
    this.ddlRequest.Role = this.roleId;
    this.ddlRequest.Flag = this.FlagDropDown;
    this.ddlRequest.SBU = Array.prototype.map.call(filter, function (item) { return item.id; }).join(",");
    //this.ddlServices.getZoneHierarchyDropDown(this.ddlRequest)
    this.ddlServices.getSBUHierarchyDropDown(this.ddlRequest)
      .subscribe((response) => {
        if (response.status) {
          this.rmh.selectedItems = [];
          this.regionSelect.selectedItems = [];
          this.zone.selectedItems = [];
          this.division.selectedItems = [];
          this.ddlResponse.division = response.data.division;
          this.ddlResponse.zone = response.data.zone;
          this.ddlResponse.region = response.data.region;
          this.ddlResponse.rmh = response.data.rmh;

          this.division.selectedItems = response.data.division.map(item => { return { id: item.divisionCode, text: item.divisionName } });
          this.zone.selectedItems = response.data.zone.map(item => { return { id: item.zoneCode, text: item.zoneName } });
          this.regionSelect.selectedItems = response.data.region.map(item => { return { id: item.regionCode, text: item.regionName } });
          this.rmh.selectedItems = response.data.rmh.map(item => { return { id: item.rmhCode, text: item.rmhName } });


          this.loader = 'none';
        }
        else {
          this.toastr.error(response.message);
          this.loader = 'none';
        }

      }, error => {
        this.loader = 'none';
      });
  }
  GetDivisionWiseData(filter: any) {
    this.loader = 'block';
    this.ddlRequest.UserId = this.userId;
    this.ddlRequest.Role = this.roleId;
    this.ddlRequest.Flag = this.FlagDropDown;
    this.ddlRequest.Division = Array.prototype.map.call(filter, function (item) { return item.id; }).join(",");
    this.ddlServices.getDivisionHierarchyDropDown(this.ddlRequest)
      .subscribe((response) => {
        if (response.status) {
          this.rmh.selectedItems = [];
          this.regionSelect.selectedItems = [];
          this.zone.selectedItems = [];
          this.ddlResponse.region = response.data.region;
          this.ddlResponse.zone = response.data.zone;
          this.ddlResponse.rmh = response.data.rmh;

          this.zone.selectedItems = response.data.zone.map(item => { return { id: item.zoneCode, text: item.zoneName } });
          this.regionSelect.selectedItems = response.data.region.map(item => { return { id: item.regionCode, text: item.regionName } });
          this.rmh.selectedItems = response.data.rmh.map(item => { return { id: item.rmhCode, text: item.rmhName } });


          this.loader = 'none';
        }
        else {
          this.toastr.error(response.message);
          this.loader = 'none';
        }

      }, error => {
        this.loader = 'none';
      });
  }
  GetZoneWiseData(filter: any) {
    this.loader = 'block';
    this.ddlRequest.UserId = this.userId;
    this.ddlRequest.Role = this.roleId;
    this.ddlRequest.Flag = this.FlagDropDown;
    this.ddlRequest.Zone = Array.prototype.map.call(filter, function (item) { return item.id; }).join(",");
    this.ddlServices.getZoneHierarchyDropDown(this.ddlRequest)
      .subscribe((response) => {
        if (response.status) {
          this.rmh.selectedItems = [];
          this.regionSelect.selectedItems = [];

          this.ddlResponse.region = response.data.region;
          this.ddlResponse.rmh = response.data.rmh;
          this.regionSelect.selectedItems = response.data.region.map(item => { return { id: item.regionCode, text: item.regionName } });
          this.rmh.selectedItems = response.data.rmh.map(item => { return { id: item.rmhCode, text: item.rmhName } });

          this.loader = 'none';
        }
        else {
          this.toastr.error(response.message);
          this.loader = 'none';
        }

      }, error => {
        this.loader = 'none';
      });
  }

  GetRegionWiseData(filter: any) {
    this.loader = 'block';
    this.ddlRequest.UserId = this.userId;
    this.ddlRequest.Role = this.roleId;
    this.ddlRequest.Flag = this.FlagDropDown;
    this.ddlRequest.Region = Array.prototype.map.call(filter, function (item) { return item.id; }).join(",");
    this.ddlServices.getRegionWiseRMHDropDown(this.ddlRequest)
      .subscribe((response) => {
        if (response.status) {
          if (response.data.rmh.length > 0)
            this.rmh.selectedItems = response.data.rmh.map(item => { return { id: item.rmhCode, text: item.rmhName } });
          else
            this.rmh.selectedItems = [];
          // this.rmh.selectedItems = [];
          // this.ddlResponse.rmh = response.data.rmh;
          this.loader = 'none';
        }
        else {
          this.toastr.error(response.message);
          this.loader = 'none';
        }

      }, error => {
        this.loader = 'none';
      });
  }
  GetRMHWiseData(filter: any) {
    this.loader = 'block';
    this.ddlRequest.UserId = this.userId;
    this.ddlRequest.Role = this.roleId;
    this.ddlRequest.Flag = this.FlagDropDown;
    this.ddlRequest.RMH = Array.prototype.map.call(filter, function (item) { return item.id; }).join(",");
    this.ddlServices.getRMHWiseRegionDropDown(this.ddlRequest)
      .subscribe((response) => {
        if (response.status) {
          if (response.data.region.length > 0)
            this.regionSelect.selectedItems = response.data.region.map(item => { return { id: item.regionCode, text: item.regionName } });
          else
            this.regionSelect.selectedItems = [];
          // this.regionSelect.selectedItems = [];
          // this.ddlResponse.region = response.data.region;
          this.loader = 'none';
        }
        else {
          this.toastr.error(response.message);
          this.loader = 'none';
        }

      }, error => {
        this.loader = 'none';
      });
  }
  GetSDData() {
    this.ddlRequest.UserId = this.userId;
    this.ddlRequest.Role = this.roleId;
    this.ddlServices.getSDDropDown(this.ddlRequest)
      .subscribe((response) => {
        if (response.status) {
          this.ddlResponse.sd = response.data.sd;
        }
        else {
          this.toastr.error(response.message);
        }

      }, error => {
      });
  }

  //IsOnInit==>True Means It execute on ngOnInit
  //IsOnInit==>False Means It execute on OnChnage
  GetWarehouseLocationData() {
    this.loader = 'block';
    this.ddlRequest.UserId = this.userId;
    this.ddlRequest.Role = this.roleId;
    this.ddlRequest.Flag = 'TRUE';
    this.ddlServices.getWarehouseLocationDropDown(this.ddlRequest)
      .subscribe((response) => {
        if (response.status) {
          this.ddlResponse.warehouseLocation = response.data.warehouse;
          this.loader = 'none';
        }
        else {
          this.toastr.error(response.message);
          this.loader = 'none';
        }

      }, error => {
        this.loader = 'none';
      });
  }
  GetInventory(currentPage: any) {
    let isValid = true;
    if (this.warehouseLocation.selectedItems == "" || this.warehouseLocation.selectedItems == null) {
      this.toastr.error("Please select Warehouse Location");
      isValid = false;
      return false;
    }
    if (isValid) {
      this.isDisabledPrevious = true;
      this.isDisabledNext = false;
      this.startRecord = 1;
      this.defaultValue = false;
      this.invRequestModel.userId = this.userId;
      this.invRequestModel.pageNo = currentPage;

      if (this.warehouseLocation.selectedItems.length > 0)
        this.invRequestModel.whLocation = Array.prototype.map.call(this.warehouseLocation.selectedItems, function (item) { return item.id; }).join(",");
      else
        this.invRequestModel.whLocation = '';
      if (this.commaSeperatedProduct == undefined) {
        this.commaSeperatedProduct = '';
      }
      this.invRequestModel.product = Array.prototype.map.call(this.productSelect.selectedItems, function (item) { return item.id; }).join(",");

      this.loader = 'block';
      this.inventoryService.getInventoryData(this.invRequestModel)
        .subscribe((response) => {
          if (response.status) {
            this.invResponseModel = response.data;
            this.model = response.data.inventoryData;
            this.pagination = response.data.pagination;
            console.log(this.model);
            //this.setPage(1, this.pageSetting);
            this.loader = 'none';
            this.defaultView = false;
            this.totalRecord = response.data.pagination.totalRecord;
            this.lastPage = response.data.pagination.lastPage;
            this.currentPage = response.data.pagination.currentPage;
            this.recordsOnCurrentPage = this.currentPage * 10;
            if (this.currentPage > 1) {
              this.isDisabledPrevious = false;
              this.startRecord = (this.currentPage - 1) * 10 + 1;

            }
            if (this.currentPage == this.lastPage|| this.totalRecord==0) {
              this.isDisabledNext = !this.isDisabledNext;
              this.recordsOnCurrentPage = this.totalRecord;
            }
            if (this.model.length == 0) {
              this.startRecord = 0;
              this.recordsOnCurrentPage = 0;
            }
          }
          else {
            this.toastr.error(response.message);
            this.loader = 'none';
          }

        }, error => {
          this.loader = 'none';
        });
    }

  }
  downloadFile() {
    let isValid = true;
    if (this.warehouseLocation.selectedItems == "" || this.warehouseLocation.selectedItems == null) {
      this.toastr.error("Please select WH Location");
      isValid = false;
      return false;
    }
    if (isValid) {
      this.loader = 'block';
      this.invRequestModel.userId = this.userId;
      let today = new Date();
      let month;
      if((today.getMonth() + 1)<10)
      {
          month = '0' + (today.getMonth() + 1).toString().slice(-2);
      }
      else
      {
            month =  (today.getMonth() + 1).toString().slice(-2);
      }
      let formattedDate = today.getDate() + "_" + month + "_" + today.getFullYear();
      // if (this.regionSelect.selectedItems.length > 0)
      // this.invRequestModel.region = Array.prototype.map.call(this.regionSelect.selectedItems, function (item) { return item.id; }).join(",");
      // else
      // this.invRequestModel.region = '';
      if (this.warehouseLocation.selectedItems.length > 0)
        this.invRequestModel.whLocation = Array.prototype.map.call(this.warehouseLocation.selectedItems, function (item) { return item.id; }).join(",");
      else
        this.invRequestModel.whLocation = '';
      if (this.commaSeperatedProduct == undefined) {
        this.commaSeperatedProduct = '';
      }

      this.invRequestModel.product = Array.prototype.map.call(this.productSelect.selectedItems, function (item) { return item.id; }).join(",");

      this.inventoryService.DownloadFile(this.invRequestModel)
        .subscribe(
          success => {
            if (success.ok = true) {
              var blob = new Blob([success.blob()], { type: 'application/vnc.openxmlformats-officedocument.spreadsheetxml.sheet' })
              saveAs(blob, this.userName + "_Inventory_" + formattedDate + ".xlsx");
            }
            this.loader = 'none';
          },
          err => {
            this.toastr.error("No data found");
            //alert("No data found");
            //alert("Some problem occurred while downloading file.");
            this.loader = 'none';
          }
        );
    }
  }


  // Start :For Pagination
  // setPage(page: number, pageSize: number) {
  //   // get pager object from service
  //   if (this.modalSetting == 0) {
  //     this.pager = this._pagerService.getPager(this.invResponseModel.length, page, pageSize);
  //     this.model = this.invResponseModel.slice(this.pager.startIndex, this.pager.endIndex + 1);
  //   }
  //   else {
  //     if (this.modalSetting == 1) {
  //       this.pager = this._pagerService.getPager(this.invResponseModel.length, page, pageSize);
  //       this.model = this.invResponseModel.slice(this.pager.startIndex, this.pager.endIndex + 1);
  //     }
  //     else {
  //       this.pager = this._pagerService.getPager(this.modelDepandent.length, page, pageSize);
  //       this.model = this.modelDepandent.slice(this.pager.startIndex, this.pager.endIndex + 1);
  //     }
  //   }
  //   // get current page of items
  // }
  // onSelectPaging(val: any): void {
  //   if (val == "0") {
  //     this.model = this.invResponseModel;
  //     this.pageSetting = 10;
  //   }
  //   else {
  //     this.pageSetting = val == "1" ? 20 : 30;
  //   }
  //   this.modalSetting = 0;
  //   this.setPage(1, this.pageSetting);
  // }
  // END :For Pagination

}
